import { render, staticRenderFns } from "./ticketdetails.vue?vue&type=template&id=5cb5ae8c&"
import script from "./ticketdetails.vue?vue&type=script&lang=js&"
export * from "./ticketdetails.vue?vue&type=script&lang=js&"
import style0 from "./ticketdetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports